<template>
  <div class="container page">
    <!-- 顶部导航 -->
    <div class="header">
      <van-nav-bar
        :title="$t('recharge.recharge')"
        class="nav-bar"
        left-arrow
        @click-left="back"
      >
        <template #left>
          <van-icon name="arrow-left" color="#333" />
        </template>
        <template #right>
          <span class="history-link" @click="$router.push({path:'/RechargeRecord'});">{{$t('foorter.ti_record')}}</span>
        </template>
      </van-nav-bar>
    </div>

    <!-- 充值内容主体 -->
    <div class="content">
      
      <!-- USDT 地址区域 (根据当前选中的支付方式显示) -->
      <div class="address-section" v-if="pay_way === 'USDT-TRC20' || pay_way === 'USDT-ERC20'">
        <div class="address-title">[{{ pay_way }}]</div>
        
        <div class="address-box">
          <span class="address-text">{{ currentAddress }}</span>
          <span class="copy-btn" @click="copyAddress">Copy</span>
        </div>

        <!-- 二维码展示 (从接口获取) -->
        <div class="qr-placeholder">
          <template v-if="currentQrCode">
            <img :src="currentQrCode" class="qr-img" />
          </template>
          <template v-else>
            <div class="qr-img-placeholder">loading...</div>
          </template>
        </div>
      </div>

      <!-- 支付方式选择 -->
      <div class="pay-method-section">
        <div class="section-label">{{$t('recharge.pay_way')}}</div>
        <div class="pay-options">
          <div 
            class="pay-option" 
            :class="{ 'active': pay_way === 'USDT-TRC20' }"
            @click="pay_way = 'USDT-TRC20'"
          >
            USDT-TRC20
          </div>
          <div 
            class="pay-option" 
            :class="{ 'active': pay_way === 'USDT-ERC20' }"
            @click="pay_way = 'USDT-ERC20'"
          >
            USDT-ERC20
          </div>
        </div>
      </div>

      <!-- 充值金额输入 -->
      <div class="amount-section">
        <div class="amount-icon">💰</div>
        <input 
          type="number" 
          v-model="money" 
          class="amount-input" 
          :placeholder="$t('recharge.input_money')"
        />
      </div>

      <!-- 上传付款截图（带图片预览） -->
      <div class="upload-section" @click="triggerFileUpload">
        <template v-if="uploadedFile">
          <img :src="uploadedFileUrl" class="upload-preview" style="width: 50px;height: 50px;" />
        </template>
        <template v-else>
          <van-icon name="photograph" size="24" color="#333" />
          <div class="upload-text">{{$t('auth.top19')}}</div>
        </template>
        <input 
          type="file" 
          ref="fileInput" 
          accept="image/*" 
          style="display: none" 
          @change="handleFileChange"
        />
      </div>

      <!-- 立即充值按钮 -->
      <button class="submit-btn" @click="onSubmit">{{$t('auth.top20')}}</button>

    </div>
  </div>
</template>
  
<script>
import Vue from "vue";
import { Form, Field, RadioGroup, Radio, Icon, Toast } from "vant";
Vue.use(Form).use(Field).use(RadioGroup).use(Radio).use(Icon).use(Toast);

export default {
  data() {
    return {
      balance: 0,
      pay_way: "USDT-TRC20",
      money: "",
      uploadedFile: null,
      uploadedFileUrl: "",
      // 新增：图片 Base64 数据
      screenshotBase64: "",
      // 所有钱包数据
      walletData: {
        "USDT-TRC20": { address: "", qrcode: "" },
        "USDT-ERC20": { address: "", qrcode: "" }
      }
    };
  },
  computed: {
    // 根据当前支付方式获取对应的地址和二维码
    currentAddress() {
      return this.walletData[this.pay_way]?.address || "";
    },
    currentQrCode() {
      return this.walletData[this.pay_way]?.qrcode || "";
    }
  },
  mounted() {
    this.balance = this.$route.params.balance || 0;
    // 页面加载时只请求一次，获取所有钱包数据
    this.getAllRecharges();
  },
  methods: {
    back() {
      window.history.back();
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
        this.uploadedFileUrl = URL.createObjectURL(file);
        
        // 【新增】使用 FileReader 将图片转为 Base64
        const reader = new FileReader();
        reader.onload = (e) => {
          this.screenshotBase64 = e.target.result; // 这里存的是 data:image/png;base64,...
          console.log('✅ 图片已转为 Base64');
        };
        reader.readAsDataURL(file);
      }
    },
    copyAddress() {
      if (!this.currentAddress) return;
      const input = document.createElement('input');
      input.value = this.currentAddress;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast.success(this.$t('auth.top21'));
    },
    // 一次性获取所有充值信息
    getAllRecharges() {
      this.$http({
        method: "get",
        url: "recharges"
      }).then((res) => {
        if (res.code === 200) {
          const data = res.data;
          
          // 根据后端明确的数据格式直接赋值
          if (data.TRC20) {
            this.walletData["USDT-TRC20"] = {
              address: data.TRC20.address || "",
              qrcode: data.TRC20.qrcode || ""
            };
          }
          
          if (data.ERC20) {
            this.walletData["USDT-ERC20"] = {
              address: data.ERC20.address || "",
              qrcode: data.ERC20.qrcode || ""
            };
          }

          console.log('✅ walletData:', this.walletData);

        } else {
          this.$toast(res.msg || this.$t('auth.top26'));
        }
      }).catch((err) => {
        console.error('❌ 请求失败:', err);
        this.$toast(this.$t('auth.top27'));
      });
    },
    onSubmit() {
      const money = this.money;
      if (!money || money <= 0) {
        this.$toast(this.$t("reservation.money_err") || this.$t('auth.top22'));
        return;
      }
      if (!this.uploadedFile) {
        this.$toast(this.$t('auth.top23'));
        return;
      }
      if (!this.screenshotBase64) {
        this.$toast('图片正在转换中，请稍后再试');
        return;
      }

      // 【重点修改】直接提交 JSON 对象，不是 FormData
      const postData = {
        pay_way: this.pay_way,
        money: money,
        screenshot: this.screenshotBase64 // 传给后端的 Base64 图片字符串
      };

      this.$http({
        method: "post",
        data: postData, // 直接传纯对象
        url: "recharge"
        // 注意：这里不需要 Content-Type: multipart/form-data，因为不是 FormData
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.$toast.success(this.$t('auth.top24'));
          if (res.data.pay_url) {
            window.location.href = res.data.pay_url;
          } else {
            this.money = "";
            this.uploadedFile = null;
            this.uploadedFileUrl = "";
            this.screenshotBase64 = ""; // 清空 Base64
            this.$refs.fileInput.value = "";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        } else {
          this.$toast(res.msg || this.$t('auth.top25'));
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    }
  }
};
</script>
  
<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  background: #f5f5f5;
  min-height: 100vh;
}

.header {
  background: #fff;
  .nav-bar {
    background: #fff;
    /deep/ .van-nav-bar__title {
      color: #333;
    }
    /deep/ .van-icon {
      color: #333 !important;
    }
  }
  .history-link {
    background: linear-gradient(90deg, #fc78af, #f22678);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 14PX;
    font-weight: 500;
  }
}

.content {
  padding: 20PX;
  background: #fff;
  margin: 10PX 10PX 0 10PX;
  border-radius: 12PX;
  box-shadow: 0 2PX 8PX rgba(0,0,0,0.05);
}

/* --- USDT 地址区域 --- */
.address-section {
  margin-bottom: 20PX;
  border-bottom: 1PX solid #f0f0f0;
  padding-bottom: 20PX;
}
.address-title {
  font-size: 16PX;
  font-weight: 600;
  color: #333;
  margin-bottom: 4PX;
}
.address-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f8f8;
  padding: 10PX 12PX;
  border-radius: 8PX;
  margin-bottom: 12PX;
}
.address-text {
  font-size: 13PX;
  color: #333;
  flex: 1;
  word-break: break-all;
}
.copy-btn {
  color: #999;
  font-size: 13PX;
  cursor: pointer;
  margin-left: 10PX;
  flex-shrink: 0;
}
.qr-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10PX;
}
.qr-img {
  max-width: 120PX;
  max-height: 120PX;
  border-radius: 8PX;
}
.qr-img-placeholder {
  width: 120PX;
  height: 120PX;
  background: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14PX;
  color: #999;
  border-radius: 8PX;
}

/* --- 支付方式选择 --- */
.pay-method-section {
  margin-bottom: 20PX;
}
.section-label {
  font-size: 15PX;
  font-weight: 500;
  color: #333;
  margin-bottom: 12PX;
}
.pay-options {
  display: flex;
  gap: 10PX;
  flex-wrap: wrap;
}
.pay-option {
  flex: 1;
  min-width: 80PX;
  height: 40PX;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
  color: #333;
  border-radius: 20PX;
  font-size: 14PX;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.pay-option.active {
  background: linear-gradient(90deg, #fc78af, #f22678);
  color: #fff;
}

/* --- 金额输入 --- */
.amount-section {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8PX;
  padding: 0 16PX;
  margin-bottom: 16PX;
}
.amount-icon {
  font-size: 20PX;
  margin-right: 10PX;
  color: #ccc;
}
.amount-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  height: 48PX;
  font-size: 16PX;
  color: #333;
}
.amount-input::placeholder {
  color: #ccc;
}

/* --- 上传截图（带预览） --- */
.upload-section {
  width: 100%;
  height: 100PX;
  background: #dcdcdc;
  border-radius: 8PX;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 8PX;
  overflow: hidden;
  position: relative;
}
.upload-text {
  margin-top: 8PX;
  font-size: 14PX;
  color: #333;
}
.upload-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* --- 提交按钮 --- */
.submit-btn {
  width: 100%;
  height: 48PX;
  background: linear-gradient(90deg, #fc78af, #f22678);
  color: #fff;
  border: none;
  border-radius: 24PX;
  font-size: 16PX;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}
.submit-btn:active {
  opacity: 0.8;
}
</style>